import osmtogeojson from "osmtogeojson";

export const fetchOverpassTurbo = async (overPassCode: string) => {
  const endpoint = "https://overpass-api.de/api/interpreter";
  const response = await fetch(endpoint, {
    method: "POST",
    headers: { "Content-Type": "text/plain" },
    body: overPassCode
  });

  if (!response.ok) {
    throw new Error(`Error querying Overpass API: ${response.statusText}`);
  }

  const data = await response.json();
  const geojson = osmtogeojson(data);

  return geojson;
};

